
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-472d28fc&scoped=true!sass-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./services-b2b-sodre.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./services-b2b-sodre.vue"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-472d28fc!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./services-b2b-sodre.vue"),
  /* scopeId */
  "data-v-472d28fc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/external/services-b2b-sodre.vue
// module id = 2023
// module chunks = 1